/**
 * Isla Green — Horizon Shopify.actions overrides
 *
 * Goals:
 * - Keep cart updates working normally.
 * - Never redirect customers to /cart after Add to cart.
 * - Do not automatically open the cart drawer.
 * - Customers remain on the page where they added the product.
 */

function init() {
  const actions = window.Shopify?.actions;

  if (!actions) return;

  /**
   * Keep cart update events scoped to the cart drawer when available.
   */
  actions.updateCart.configure({
    eventTarget: () =>
      document.querySelector('theme-drawer#cart-drawer') ??
      document,
  });

  /**
   * Disable automatic cart opening/redirection.
   *
   * Add to cart will:
   * - add the product
   * - update the cart
   * - keep the customer on the current page
   *
   * The customer can still manually click the cart icon.
   */
  actions.openCart.configure({
    async handler() {
      return;
    },
  });
}


/**
 * Run immediately if Shopify.actions already exists.
 * Otherwise wait until the page finishes initializing.
 */
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    init,
    { once: true }
  );
}